// W2Cook Billing Dashboard — Environment & Limits types

export type Environment = "dev" | "staging" | "prod";

export const ENVIRONMENTS: Environment[] = ["dev", "staging", "prod"];

export const ENV_CONFIG: Record<Environment, { label: string; color: string; badge: string }> = {
  dev:     { label: "Development", color: "#5B8FD4", badge: "DEV"     },
  staging: { label: "Staging",     color: "#C9A84C", badge: "STAGING" },
  prod:    { label: "Production",  color: "#7DB87A", badge: "PROD"    },
};

// ── Budget limits ─────────────────────────────────────────────────────────────

export interface BudgetLimits {
  totalMonthly:    number;              // 0 = no limit
  perCategory:     Record<string, number>;
  perService:      Record<string, number>;
}

export const DEFAULT_LIMITS: BudgetLimits = {
  totalMonthly: 0,
  perCategory:  {},
  perService:   {},
};

// ── Email / notification config ───────────────────────────────────────────────

export interface NotificationConfig {
  enabled:          boolean;
  recipientEmail:   string;
  senderEmail:      string;             // e.g. billing@w2cook.com
  smtpEndpoint:     string;             // Cloud Run function URL
  alerts: {
    spendExceedsLimit:  boolean;
    renewalWarning30d:  boolean;
    renewalWarning7d:   boolean;
  };
}

export const DEFAULT_NOTIFICATION_CONFIG: NotificationConfig = {
  enabled:        false,
  recipientEmail: "",
  senderEmail:    "billing@w2cook.com",
  smtpEndpoint:   "",
  alerts: {
    spendExceedsLimit: true,
    renewalWarning30d: true,
    renewalWarning7d:  true,
  },
};
